import { useLanguage } from "@/context/AppContext";

export default function Values() {
  const { t } = useLanguage();
  return (
    <section id="values" className="section values" data-testid="values-section">
      <div className="section-label">{t.values.label}</div>
      <h2 data-testid="values-section-title">{t.values.h}</h2>
      <div className="value-grid">
        {t.values.items.map((v, i) => (
          <div key={v.key} data-testid={`value-card-${v.key}`}>
            <b>{String(i + 1).padStart(2, "0")}</b>
            <h3>{v.title}</h3>
            <p>{v.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
